import { atomWithDefault } from "jotai/utils";
import { atom, useSetAtom } from "jotai";
import { isTrue } from "../../Utils/filter";
import { getTermList } from "../../API/course";
import { getStudentEvaluationStatus } from "../../API/evaluate";

//学期列表
export const termListAtom = atomWithDefault(async () => {
    return await getTermList();
});

//是否评教红点
export const studentEvaluationStatusAtom = atomWithDefault(async () => {
    return await getStudentEvaluationStatus();
});

export function useUpdateEvaluationStatusOther() {
    const updateTypes = useSetAtom(studentEvaluationStatusAtom);

    async function update() {
        const data = await getStudentEvaluationStatus();
        updateTypes(data);
    }

    return update;
}

// 获取默认的学期编码
export const batchNoAtom = atom(get => {
    const termList = get(termListAtom);
    return termList.find(item => isTrue(item.isCurrentTerm))?.batchNo;
});
